export const PROJECT_ID_IN_PATH = /^\/project\/(\d+)(\/|$)/;

export const DEVELOPMENT_HOSTNAMES = ["localhost", "127.0.0.1"];

export const PRODUCTION_HOSTNAME = "app.monco.ai";
